import { render, staticRenderFns } from "./profile.component.vue?vue&type=template&id=140bbab2&scoped=true&"
import script from "./profile.component.ts?vue&type=script&lang=ts&"
export * from "./profile.component.ts?vue&type=script&lang=ts&"
import style0 from "./profile.component.scss?vue&type=style&index=0&id=140bbab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140bbab2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
